import type { CoinView } from './model';
import { RAIL_LIMIT } from './railMotion';

export const QUEUE_LIMIT = 12;

export function predictionQueue(
  coins: CoinView[],
  now: number,
  selectedId: string | null,
) {
  // A saved choice belongs in the left rail AND stays selectable until the deadline.
  const open = coins
    .filter(
      (coin) =>
        now < coin.closesAt &&
        (coin.phase === 'open' || coin.phase === 'opening'),
    )
    .sort((a, b) => a.start - b.start);
  if (open.length <= QUEUE_LIMIT) return open;
  let from = open.length - QUEUE_LIMIT;
  const pinned = selectedId
    ? open.findIndex((coin) => coin.id === selectedId)
    : -1;
  if (pinned >= 0 && pinned < from) from = pinned;
  return open.slice(from, from + QUEUE_LIMIT);
}

// Newly confirmed calls enter first, even when the token is older than the six shown.
export function recentCallOrder(previous: string[], current: string[]) {
  const known = new Set(previous),
    available = new Set(current);
  return [
    ...current.filter((id) => !known.has(id)),
    ...previous.filter((id) => available.has(id)),
  ];
}

export function railCoins(coins: CoinView[], now: number, callOrder: string[]) {
  const called = new Map(
    coins.filter((coin) => coin.choice).map((coin) => [coin.id, coin]),
  );
  return {
    mine: callOrder
      .flatMap((id) => (called.has(id) ? [called.get(id)!] : []))
      .slice(0, RAIL_LIMIT),
    feed: coins
      .filter(
        (coin) =>
          !coin.choice &&
          (now >= coin.closesAt ||
            coin.phase === 'watching' ||
            coin.phase === 'settled'),
      )
      .slice(0, RAIL_LIMIT),
  };
}
